module.exports = "<div class=\"popup-header\">\r\n\t<div class=\"popup-title\">Поздравляем!</div>\r\n</div>\r\n<div class=\"popup-text\">\r\n\t<div>Ваш запрос успешно оформлен.</div>\r\n\t{{if status == 'pending'}}\r\n\t<div>Мы выкупим этот товар как только он появится в наличии.</div>\r\n\t{{else}}\r\n\t<div>Мы выкупим этот товар в ближайшее время.</div>\r\n\t{{/if}}\r\n</div>\r\n<div class=\"popup-buttons\">\r\n\t<button type=\"button\" class=\"popup-btn active\" rel=\"close-dialog\">Готово</button>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./modules/packages/create_order/templates/co-popup-success.html
// module id = sS8O
// module chunks = 2 3 4 5 6 11